import api from "@/apis/TransferAPI";
import Crud from "./crud-base";
import httpClient from "@/apis/base/axios-httpclient";
var crud = new Crud("Transfer", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "TransferID",
      code: "TransferNo",
      name: "TransferNo",
    },
  },
  totals: [],
};
const getters = {
  ...crud.getters,

  totals: function (state) {
    return state.totals;
  },
};
const actions = {
  ...crud.actions,

  loadTotal: async function (context, payload) {
    context.commit("updateLoading", true);
    let url = [api.getAPIUrl(), "total"];
    if (payload == true) {
      url.push(true);
    }
    let request = {
      url: url.join("/"),
    };
    let res = await httpClient.getAsync(request);
    context.commit("updateLoading", false);
    if (res) {
      context.commit("updateTotal", res);
      return res;
    }
  },
};
const mutations = {
  ...crud.mutations,

  updateTotal(state, res) {
    state.totals.removeAll();
    state.totals.append(res);
  },
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
